import { baseService } from "service/base";

class DeviceStatsService {
  /*
   * This service will fetch device stats that include device status, and
   * statistics around connection, network_uptime, strategy
   * details and view.
   */
  load(deviceId) {
    return baseService.get(`/api/device/status/${deviceId}`);
  }
}

const deviceStatsService = new DeviceStatsService();

export { deviceStatsService };
